import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axiosInstance';

// Define an async thunk to fetch data from the API

export const userSignupApi = createAsyncThunk(
  'login/userSignupApi',
  async (formData, { rejectWithValue }) => { // Accept email and password as arguments
    try {
      const response = await axiosInstance.post('/auth/register/'
        , formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const fetchUserType = createAsyncThunk(
  'usertype/fetchUserType',
  async (formData, { rejectWithValue }) => { // Accept email and password as arguments
    try {
      const response = await axiosInstance.get('/auth/getroles/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

export const fetchVendorSubTypeList = createAsyncThunk(
  'vendorsubtype/fetchVendorsubtype',
  async ({ vendor_master_name }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/community/get-all-subvendors', {
        params: {
          vendor_master_name: vendor_master_name
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)





